import * as path from 'path';

import * as dotenv from 'dotenv';
import { pino, Logger } from 'pino';

const environment = process.env.NODE_ENV || 'development';

const isDevelopment = environment === 'development';
const isProduction = environment === 'production';
const isStaging = environment === 'staging';

const isBrowser = typeof window !== 'undefined';

function createBrowserLogger(): Logger {
  return pino({
    level: isProduction ? 'info' : 'debug',
    transport:
      isDevelopment || isStaging
        ? {
            target: 'pino-pretty',
            options: {
              colorize: true,
              translateTime: 'UTC:yyyy-mm-dd HH:MM:ss.l Z', // UTC format
              ignore: 'pid,hostname',
              singleLine: false,
              messageFormat: '{msg}',
            },
          }
        : undefined,
    serializers: {
      err: pino.stdSerializers.err,
    },
  });
}

function createServerLogger(): Logger {
  dotenv.config({ path: path.resolve(process.cwd(), 'app/core/config/.env.development') });

  const logFile = path.join(
    process.cwd(),
    process.env.LOG_PATH || 'logs',
    process.env.LOG_FILE || 'app.log'
  );

  const transportTargets = [];

  // Console transport for dev/staging
  if (isDevelopment || isStaging) {
    transportTargets.push({
      level: 'debug',
      target: 'pino-pretty',
      options: {
        colorize: true,
        translateTime: 'UTC:yyyy-mm-dd HH:MM:ss.l Z', // UTC format
        ignore: 'pid,hostname',
        singleLine: false,
        messageFormat: '{msg}',
      },
    });
  }

  // File transport for all environments
  transportTargets.push({
    level: isProduction ? 'info' : 'debug',
    target: 'pino/file',
    options: { destination: logFile, mkdir: true },
  });

  return pino({
    level: isProduction ? 'info' : 'debug',
    transport: {
      targets: transportTargets,
    },
    serializers: {
      err: pino.stdSerializers.err,
    },
  });
}

const logger: Logger = isBrowser ? createBrowserLogger() : createServerLogger();

export { logger };
